import {Link, useParams} from 'react-router-dom';
import {ArrowLeft} from '@phosphor-icons/react';
import {useTenantContext} from '@/app/TenantContext';
import {TenantFooter} from '@/components/layout/TenantFooter';
import {TenantHeader} from '@/components/layout/TenantHeader';
import {tenantPath} from '@/lib/tenant/resolve';

const DEVELOPER_CONTACT = 't.me/Detroll';

export function PrivacyPage() {
  const {tenant} = useTenantContext();
  const {slug = ''} = useParams();
  const sections: {title: string; text: string}[] = [
    {
      title: 'Кто обрабатывает данные',
      text: `Оператор персональных данных — «${tenant.name}»${tenant.address ? `, ${tenant.address}` : ''}${tenant.phone ? `, телефон ${tenant.phone}` : ''}. Программу записи для студии предоставляет разработчик сервиса Detroll, он обрабатывает данные только по поручению студии.`,
    },
    {
      title: 'Какие данные',
      text: 'Имя, номер телефона, данные автомобиля, выбранная услуга, дата и время записи, комментарий к записи.',
    },
    {
      title: 'Зачем',
      text: 'Чтобы оформить запись, связаться с вами по ней, перенести или отменить её. Данные не продаются и не используются для рекламы без вашего отдельного согласия.',
    },
    {
      title: 'Где хранятся',
      text: 'Данные хранятся на сервере провайдера Supabase в США. Оформляя запись с согласием, вы разрешаете такую передачу и хранение за пределами России.',
    },
    {
      title: 'Срок хранения и ваши права',
      text: `Данные хранятся, пока студия оказывает вам услуги, и удаляются по вашему запросу. Вы можете узнать, какие данные о вас хранятся, исправить или удалить их и отозвать согласие. Для этого позвоните в студию или напишите разработчику: ${DEVELOPER_CONTACT}.`,
    },
  ];

  return (
    <div className="flex min-h-[calc(100dvh-6rem)] flex-1 flex-col">
      <TenantHeader />
      <div className="stagger mx-auto flex w-full max-w-[700px] flex-col gap-6 px-4 pb-8 pt-6">
        <Link to={tenantPath(slug)} className="flex items-center gap-2 text-[15px] text-muted-foreground">
          <ArrowLeft size={20} aria-hidden />
          На главную
        </Link>
        <h1 className="m-0 text-[32px] font-bold leading-[1.08] tracking-tight text-foreground">
          Политика конфиденциальности
        </h1>
        {sections.map((section) => (
          <div key={section.title} className="panel flex flex-col gap-2 rounded-[24px] p-5">
            <h2 className="m-0 text-[18px] font-bold text-foreground">{section.title}</h2>
            <p className="m-0 text-[16px] leading-relaxed text-muted-foreground">{section.text}</p>
          </div>
        ))}
        <p className="m-0 text-[14px] text-muted-foreground">Редакция от 06.10.2026.</p>
      </div>
      <TenantFooter />
    </div>
  );
}
